import React, { useEffect, useState } from 'react'
import { Checkdevice, ScreenWidth } from '../../../../../../components'
import { T1sim, T2sim, T3sim, T1simmobile, T2simmobile, T3simmobile } from './components'
import { Togglebutton } from '../../../../../../basic_components'
import { iconwrapper } from '../../../../../../config/commonfunctions'
import { LAPTOP_ICON, MOBILE_ICON } from '../../../../../../config/svgicons'
import './Simulator.css'


function Simulator(props) {
    const { devicewt, heroimgs, templatetype } = props

    // templatebgcolor, titletext,ntt, naw, nat, nam, urlhandler,
    const [simulatordevice, setSimulatordevice] = useState('WEB')
    const [wt, setWt] = useState(-1) // simulator wt
    const [ht, setHt] = useState(-1) // simulator ht
    const device = Checkdevice()

    useEffect(() => {
        if (device === 'WEB') {
            if (simulatordevice === 'WEB') {
                if (devicewt < 1190) {
                    setWt(400 * 1.4)
                    setHt(280 * 1.6)
                }
                else {
                    setWt(400 * 1.5)
                    setHt(280 * 1.7)
                }
            }
            else if (simulatordevice === 'MOBILE') {
                setWt(380 * 0.8)
                setHt(600 * 0.8)
            }
        }
        else if (device === 'TABLET') {
            if (simulatordevice === 'WEB') {
                // setWt(410)
                // setHt(300)
                setWt(400 * 1.4)
                setHt(280 * 1.6)
            }
            else if (simulatordevice === 'MOBILE') {
                setWt(380 * 0.8)
                setHt(600 * 0.8)
            }
        }
    }, [simulatordevice, device,devicewt])

    // useEffect(() => {
    //     if (device === 'WEB') {
    //         if (simulatordevice === 'WEB') {
    //             if (devicewt < 1190) {
    //                 setWt(400 * 1.4)
    //                 setHt(280 * 1.6)
    //             }
    //             else {
    //                 setWt(400 * 1.5)
    //                 setHt(280 * 1.7)
    //             }
    //         }
    //         else if (simulatordevice === 'MOBILE') {
    //             setWt(380 * 0.8)
    //             setHt(600 * 0.8)
    //         }
    //     }
    //     else if (device === 'TABLET') {
    //         if (simulatordevice === 'WEB') {
    //             setWt(400 * 1.4)
    //             setHt(280 * 1.6)
    //         }
    //         else if (simulatordevice === 'MOBILE') {
    //             setWt(380 * 0.8)
    //             setHt(600 * 0.8)
    //         }
    //     }
    // }, [devicewt])

    return <div className="simulator_root sketchbg">
        <div className='simulator_deviceroot'>
            <Togglebutton
                singlebtnstyle={{ width: 40, height: 40 }}
                funcs={[
                    () => { setSimulatordevice('WEB') },
                    () => { setSimulatordevice('MOBILE') },
                ]}
                txts={[
                    iconwrapper(LAPTOP_ICON, { width: 25, height: 25 }),
                    iconwrapper(MOBILE_ICON, { width: 25, height: 25 })
                ]}
                btnselected={{ 'WEB': 0, 'MOBILE': 1 }[simulatordevice]}
            />
        </div>

        {heroimgs.length > 0
            ? {
                'WEB':
                    {
                        1: <T1sim {...props} wt={wt} ht={ht} />,
                        2: <T2sim {...props} wt={wt} ht={ht} />,
                        3: <T3sim {...props} wt={wt} ht={ht} />,
                    }[templatetype],
                'MOBILE':
                    {
                        1: <T1simmobile {...props} wt={wt} ht={ht} />,
                        2: <T2simmobile {...props} wt={wt} ht={ht} />,
                        3: <T3simmobile {...props} wt={wt} ht={ht} />,
                    }[templatetype]
            }[simulatordevice]
            : null}
    </div>
}

export default Simulator